import { render } from "./칭찬합니다.vue?vue&type=template&id=393ddfaf"
const script = {}

import "./칭찬합니다.vue?vue&type=style&index=0&id=393ddfaf&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__